import type { RouteObject } from 'react-router';
import { PageDelegations } from './PageDelegations';
import { PageHabilitations } from './PageHabilitations';
import { PageHistorique } from './PageHistorique';
import { PageModules } from './PageModules';
import { PageParametres } from './PageParametres';
import { PageRoles } from './PageRoles';
import { PageUtilisateurs } from './PageUtilisateurs';

export const routesAdministration: RouteObject[] = [
  { path: '/administration/utilisateurs', element: <PageUtilisateurs /> },
  { path: '/administration/roles', element: <PageRoles /> },
  { path: '/administration/habilitations', element: <PageHabilitations /> },
  { path: '/administration/delegations', element: <PageDelegations /> },
  { path: '/administration/parametres', element: <PageParametres /> },
  { path: '/administration/modules', element: <PageModules /> },
  { path: '/administration/historique', element: <PageHistorique /> },
];
